var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormHelper',{ref:"formHelper",attrs:{"form":_vm.form,"config":_vm.config},model:{value:(_vm.textTemplate),callback:function ($$v) {_vm.textTemplate=$$v},expression:"textTemplate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }